import { render } from "./ListaPianoDiFatturazione.vue?vue&type=template&id=72ee4f1f&ts=true"
import script from "./ListaPianoDiFatturazione.vue?vue&type=script&lang=ts"
export * from "./ListaPianoDiFatturazione.vue?vue&type=script&lang=ts"

import "./ListaPianoDiFatturazione.vue?vue&type=style&index=0&id=72ee4f1f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__